import React from 'react';
import { Box, HStack, Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react';
import { Separator } from '@components';

export default function OfferSkeleton() {
    return (
        <Box w="100%" fontSize="14px">
            <Box display="flex" justifyContent="space-between" flexDir="row" flexWrap="wrap" pos="relative">
                <Box display="inline-block">
                    <SkeletonCircle size="80px" display="inline-block" verticalAlign="middle"/>
                    <Box display="inline-block" ml="1rem" verticalAlign="middle" maxW="calc(100% - 96px)">
                        <SkeletonText noOfLines={2} w="100px"/>
                    </Box>
                </Box>
                <HStack
                    w={["","","200px"]} 
                    h={["115px","","auto"]} 
                    pos={["absolute","","initial"]} 
                    top="0" right="0" 
                    justifyContent="space-between" 
                    alignItems={["flex-end","","center"]}
                    flexDir={["column-reverse", "", "row"]}>
                    <Skeleton border="solid 2px" borderRadius="99px" w="150px" h="40px" />
                    <SkeletonCircle size="28px"/>
                </HStack>
            </Box>

            <SkeletonText noOfLines={1} w="100px" mt={["80px","","28px"]} mb="15px" />
            <SkeletonText noOfLines={8} w="300px"/>
            <Separator ml="1.5rem !important" my="16px !important" />
            <SkeletonText noOfLines={4} w="80%" />
        </Box>
    )
};